import {gql} from 'apollo-angular';
import {ProfessionPreviewFragment} from "./fragments/ProfessionPreview";
import {ContactGalleryFragment} from "./fragments/ContactGallery";
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
import {StoryFragment} from "./fragments/Story";

export const GET_SCHOOL_PROFILE_BY_ID = gql`
  query GetSchoolProfileById($id: Int, $uuid: String) {
    schoolProfile(id: $id, uuid: $uuid) {
      id
      name
      uuid
      description
      quizUrl
      logoStyle
      headerPicture {
        ...imageFields
      }
      schoolProfilePicture {
        ...imageFields
      }
      locations {
        name
        address {
          street
          number
          addressCity {
            name
            addressDistrict {
              name
            }
          }
          addressLatLon {
            lat
            lon
          }
        }
      }
      jobs {
        ...professionPreviewFields,
      }
      documents {
        galleryItems {
          id
          contentType
          document {
            id
            filePath
            name
          }
        }
      }
      trainingInformation
      certificateInformation
      url
      contactGallery {
        ...contactGalleryFields
      }
      profileLink {
        entries {
          linkType
          linkValue
        }
      }
      mediaGallery {
        ...mediaGalleryFields
      }
      offers {
        id
        offerType
        name
        dateFrom
        dateTo
      }
      relatedSchools {
          id
          uuid
          name
          schoolProfilePicture {
              ...imageFields
          }
          jobs {
              id
              name
            interestFields {
              id
            }
          }
          locations {
              name
              address {
                  street
                  addressCity {
                      name
                      addressDistrict {
                          name
                      }
                  }
                  addressLatLon {
                      lat
                      lon
                  }
              }
          }
      }
      stories {
        ...storyFields
      }
      videoUrl
    }
  }
  ${ProfessionPreviewFragment}
  ${ContactGalleryFragment}
  ${ImageFragment}
  ${MediaGalleryFragment}
  ${StoryFragment}
`;
